import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'
import {StoreExtraArgs} from '../types/store-extra-arg'

export const createAsyncAction = asyncActionsFactory<State, StoreExtraArgs>()
